import i18n from '../../lang/index'
const bareRouter = [{
  path: '/baremetal',
  component: () => import('@/pages/Index'),

  redirect: {
    name: 'baremetal'
  },
  children: [{
    name: 'baremetal',
    path: 'index',
    component: () => import('@/pages/baremetal/Index'),
    redirect: {
      name: 'baremetallist'
    },
    children: [{
      name: 'baremetallist',
      path: 'baremetal',
      meta: {
        tab: 'baremetal',
        title: i18n.t('bms.title'),
      },
      component: () => import('@/pages/baremetal/BareMetal')
    },
    {
      name: 'securitygroups',
      path: 'groups',
      meta: {
        tab: 'groups',
        title: i18n.t('bms.list.SecurityGroupstitle'),
      },
      component: () => import('@/pages/baremetal/SecurityGroups')
    },
    {
      path: 'ip',
      name: 'IP',
      meta: {
        tab: 'ip',
        title: i18n.t('bms.list.IPtitle'),
      },
      component: () => import('@/pages/baremetal/Bandwidth')
    },
    {
      path: 'intranet',
      name: 'bmsintranet',
      meta: {
        tab: 'intranet',
        title: i18n.t('bms.list.Intranetstitle'),
      },
      component: () => import('@/pages/baremetal/Intranet')
    }

    ]
  },
  {
    name: 'bmsgroupdetail',
    path: 'index/groups/detail',
    component: () => import('@/pages/baremetal/GroupsDetail')
  }, {
    name: 'baremetaletail',
    path: 'index/baremetal/detail',
    component: () => import('@/pages/baremetal/BareMetalDetail')
  },
  {
    name: 'bmsintranetdetail',
    path: 'index/intranet/detail',
    component: () => import('@/pages/baremetal/IntranetDetail')
  }
  ]
}]
export default bareRouter



// WEBPACK FOOTER //
// ./src/router/modules/baremetal.js